import { render, staticRenderFns } from "./FieldsProductDays.vue?vue&type=template&id=5fe8289c&"
import script from "./FieldsProductDays.vue?vue&type=script&lang=js&"
export * from "./FieldsProductDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports